export const TRACKING_PLAN_DOCS =
  'https://www.rudderstack.com/docs/data-governance/tracking-plans/';
